"use client";

import { useRef, useEffect } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Image as DreiImage, useTexture } from "@react-three/drei";
import { NANO_BANANA_PROMPTS } from "@/content/prompts";
import * as THREE from "three";
import gsap from "gsap";

function InteractivePortrait() {
    const ref = useRef<THREE.Mesh>(null);
    const materialRef = useRef<THREE.ShaderMaterial>(null);

    const url = "/media/Hikari_Hero_001.jpeg"; // Final Hero Asset

    useFrame((state) => {
        if (ref.current) {
            // Subtle breathing motion or parallax could go here
            // For now, we rely on the scroll trigger in the parent for scale
        }
    });

    return (
        <DreiImage
            ref={ref}
            url={url}
            transparent
            opacity={0.5}
            scale={[12, 18]} // Increased scale to cover viewport
            position={[0, -3, -1]} // Shifted down to bring face into view
        />
    );
}


export default function PersistentHero() {
    return (
        <div className="fixed inset-0 z-0 w-full h-full bg-[#EAE8E4] overflow-hidden">
            {/* R3F Canvas for the 'Living' Image */}
            <Canvas className="w-full h-full">
                <InteractivePortrait />
            </Canvas>

            {/* Hero Text Overlay - Pinned initially, will be covered or parallaxed */}
            <div className="absolute inset-0 flex flex-col items-center justify-center z-10 pointer-events-none mix-blend-difference">
                <h1 className="font-display text-[15vw] md:text-[20vw] leading-none text-white tracking-tighter opacity-90">
                    HIKARI.
                </h1>

            </div>

            {/* Grain/Texture Overlay */}
            <div className="absolute inset-0 pointer-events-none opacity-[0.03] z-20 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] bg-repeat" />
        </div>
    );
}
